import type { LivrableTangibleParTactique } from './livrablesTangiblesParTactique';

export type ProjetEHCyberHolistiqueTask = LivrableTangibleParTactique & {
  sourceLabel: string;
  sourceUrl: string;
};

export const projetEHCyberHolistiqueTasks: ProjetEHCyberHolistiqueTask[] = 
[
  {
    "id": "cyber-holistique-1-autres-reponse-a-des-incidents-etc",
    "pilierId": 5,
    "pilierNom": "Modèle Cyber Holistique",
    "tactiqueId": "CH",
    "tactiqueNom": "Tâches du modèle Cyber Holistique",
    "livrableNom": "Autres (réponse à des incidents, etc.)",
    "description": "Tâche importée du modèle Asana Modèle Cyber Holistique.",
    "type": "Document",
    "standard": "ITIL",
    "profondeur": "Mixte",
    "mentionneSolutionsAffaires": true,
    "sourceLabel": "Modèle Cyber Holistique",
    "sourceUrl": "https://app.asana.com/1/1161204849683002/project/1216173532334464/task/1216173472771899"
  },
  {
    "id": "cyber-holistique-1-balayage-de-vulnerabilites",
    "pilierId": 5,
    "pilierNom": "Modèle Cyber Holistique",
    "tactiqueId": "CH",
    "tactiqueNom": "Tâches du modèle Cyber Holistique",
    "livrableNom": "Balayage de vulnérabilités",
    "description": "Tâche importée du modèle Asana Modèle Cyber Holistique.",
    "type": "Rapport",
    "standard": "NIST",
    "profondeur": "Technologique",
    "mentionneSolutionsAffaires": true,
    "sourceLabel": "Modèle Cyber Holistique",
    "sourceUrl": "https://app.asana.com/1/1161204849683002/project/1216173532334464/task/1216173449592226"
  },
  {
    "id": "cyber-holistique-1-campagne-d-hameconnage",
    "pilierId": 5,
    "pilierNom": "Modèle Cyber Holistique",
    "tactiqueId": "CH",
    "tactiqueNom": "Tâches du modèle Cyber Holistique",
    "livrableNom": "Campagne d'hameçonnage",
    "description": "Tâche importée du modèle Asana Modèle Cyber Holistique.",
    "type": "Rapport",
    "standard": "NIST",
    "profondeur": "Mixte",
    "mentionneSolutionsAffaires": true,
    "sourceLabel": "Modèle Cyber Holistique",
    "sourceUrl": "https://app.asana.com/1/1161204849683002/project/1216173532334464/task/1216173472771497"
  },
  {
    "id": "cyber-holistique-1-catalogue-des-actifs-inventaire-des-donnees-sensibles-a-proteger",
    "pilierId": 5,
    "pilierNom": "Modèle Cyber Holistique",
    "tactiqueId": "CH",
    "tactiqueNom": "Tâches du modèle Cyber Holistique",
    "livrableNom": "Catalogue des actifs + Inventaire des données sensibles à protéger",
    "description": "Tâche importée du modèle Asana Modèle Cyber Holistique.",
    "type": "Outil",
    "standard": "BZ",
    "profondeur": "Technologique",
    "mentionneSolutionsAffaires": true,
    "sourceLabel": "Modèle Cyber Holistique",
    "sourceUrl": "https://app.asana.com/1/1161204849683002/project/1216173532334464/task/1216173449592202"
  },
  {
    "id": "cyber-holistique-1-diagramme-des-flux-de-donnees",
    "pilierId": 5,
    "pilierNom": "Modèle Cyber Holistique",
    "tactiqueId": "CH",
    "tactiqueNom": "Tâches du modèle Cyber Holistique",
    "livrableNom": "Diagramme des flux de données",
    "description": "Tâche importée du modèle Asana Modèle Cyber Holistique.",
    "type": "Outil",
    "standard": "BZ",
    "profondeur": "Technologique",
    "mentionneSolutionsAffaires": true,
    "sourceLabel": "Modèle Cyber Holistique",
    "sourceUrl": "https://app.asana.com/1/1161204849683002/project/1216173532334464/task/1216173449592214"
  },
  {
    "id": "cyber-holistique-1-diagramme-reseau",
    "pilierId": 5,
    "pilierNom": "Modèle Cyber Holistique",
    "tactiqueId": "CH",
    "tactiqueNom": "Tâches du modèle Cyber Holistique",
    "livrableNom": "Diagramme réseau",
    "description": "Tâche importée du modèle Asana Modèle Cyber Holistique.",
    "type": "Outil",
    "standard": "BZ",
    "profondeur": "Technologique",
    "mentionneSolutionsAffaires": true,
    "sourceLabel": "Modèle Cyber Holistique",
    "sourceUrl": "https://app.asana.com/1/1161204849683002/project/1216173532334464/task/1216173449592208"
  },
  {
    "id": "cyber-holistique-1-plan-d-intervention-en-cas-d-incident-cyber-matric-raci",
    "pilierId": 5,
    "pilierNom": "Modèle Cyber Holistique",
    "tactiqueId": "CH",
    "tactiqueNom": "Tâches du modèle Cyber Holistique",
    "livrableNom": "Plan d'intervention en cas d'incident cyber / Matric RACI",
    "description": "Tâche importée du modèle Asana Modèle Cyber Holistique.",
    "type": "Matrice",
    "standard": "RACI",
    "profondeur": "Procédurale",
    "mentionneSolutionsAffaires": true,
    "sourceLabel": "Modèle Cyber Holistique",
    "sourceUrl": "https://app.asana.com/1/1161204849683002/project/1216173532334464/task/1216173472771881"
  },
  {
    "id": "cyber-holistique-1-plan-de-formation-en-cybersecurite",
    "pilierId": 5,
    "pilierNom": "Modèle Cyber Holistique",
    "tactiqueId": "CH",
    "tactiqueNom": "Tâches du modèle Cyber Holistique",
    "livrableNom": "Plan de formation en cybersécurité",
    "description": "Tâche importée du modèle Asana Modèle Cyber Holistique.",
    "type": "Document",
    "standard": "Formation",
    "profondeur": "Mixte",
    "mentionneSolutionsAffaires": true,
    "sourceLabel": "Modèle Cyber Holistique",
    "sourceUrl": "https://app.asana.com/1/1161204849683002/project/1216173532334464/task/1216173472771509"
  },
  {
    "id": "cyber-holistique-1-plan-de-reprise-en-cas-sinistre-matrice-raci",
    "pilierId": 5,
    "pilierNom": "Modèle Cyber Holistique",
    "tactiqueId": "CH",
    "tactiqueNom": "Tâches du modèle Cyber Holistique",
    "livrableNom": "Plan de reprise en cas sinistre / Matrice RACI",
    "description": "Tâche importée du modèle Asana Modèle Cyber Holistique.",
    "type": "Matrice",
    "standard": "RACI",
    "profondeur": "Procédurale",
    "mentionneSolutionsAffaires": true,
    "sourceLabel": "Modèle Cyber Holistique",
    "sourceUrl": "https://app.asana.com/1/1161204849683002/project/1216173532334464/task/1216173472771521"
  },
  {
    "id": "cyber-holistique-1-plan-de-sauvegarde",
    "pilierId": 5,
    "pilierNom": "Modèle Cyber Holistique",
    "tactiqueId": "CH",
    "tactiqueNom": "Tâches du modèle Cyber Holistique",
    "livrableNom": "Plan de sauvegarde",
    "description": "Tâche importée du modèle Asana Modèle Cyber Holistique.",
    "type": "Document",
    "standard": "ITIL",
    "profondeur": "Mixte",
    "mentionneSolutionsAffaires": true,
    "sourceLabel": "Modèle Cyber Holistique",
    "sourceUrl": "https://app.asana.com/1/1161204849683002/project/1216173532334464/task/1216173472771515"
  },
  {
    "id": "cyber-holistique-1-politique-de-cybersecurite-cadre-d-utilisation",
    "pilierId": 5,
    "pilierNom": "Modèle Cyber Holistique",
    "tactiqueId": "CH",
    "tactiqueNom": "Tâches du modèle Cyber Holistique",
    "livrableNom": "Politique de cybersécurité - Cadre d'utilisation",
    "description": "Tâche importée du modèle Asana Modèle Cyber Holistique.",
    "type": "Document",
    "standard": "NIST",
    "profondeur": "Procédurale",
    "mentionneSolutionsAffaires": true,
    "sourceLabel": "Modèle Cyber Holistique",
    "sourceUrl": "https://app.asana.com/1/1161204849683002/project/1216173532334464/task/1216173472771887"
  },
  {
    "id": "cyber-holistique-1-politique-de-cybersecurite-cadre-de-gestion-matrice-raci",
    "pilierId": 5,
    "pilierNom": "Modèle Cyber Holistique",
    "tactiqueId": "CH",
    "tactiqueNom": "Tâches du modèle Cyber Holistique",
    "livrableNom": "Politique de cybersécurité - Cadre de Gestion / Matrice RACI",
    "description": "Tâche importée du modèle Asana Modèle Cyber Holistique.",
    "type": "Matrice",
    "standard": "RACI",
    "profondeur": "Procédurale",
    "mentionneSolutionsAffaires": true,
    "sourceLabel": "Modèle Cyber Holistique",
    "sourceUrl": "https://app.asana.com/1/1161204849683002/project/1216173532334464/task/1216173472771893"
  },
  {
    "id": "cyber-holistique-1-premiere-rencontre-introduction-discuter-de-l-ordre-des-objectifs",
    "pilierId": 5,
    "pilierNom": "Modèle Cyber Holistique",
    "tactiqueId": "CH",
    "tactiqueNom": "Tâches du modèle Cyber Holistique",
    "livrableNom": "Première rencontre (introduction + discuter de l'ordre des objectifs)",
    "description": "Tâche importée du modèle Asana Modèle Cyber Holistique.",
    "type": "Processus",
    "standard": "BZ",
    "profondeur": "Humaine",
    "mentionneSolutionsAffaires": true,
    "sourceLabel": "Modèle Cyber Holistique",
    "sourceUrl": "https://app.asana.com/1/1161204849683002/project/1216173532334464/task/1216173500990222"
  },
  {
    "id": "cyber-holistique-1-programme-loi-25-annee-1",
    "pilierId": 5,
    "pilierNom": "Modèle Cyber Holistique",
    "tactiqueId": "CH",
    "tactiqueNom": "Tâches du modèle Cyber Holistique",
    "livrableNom": "Programme Loi 25",
    "description": "Tâche importée du modèle Asana Modèle Cyber Holistique.",
    "type": "Document",
    "standard": "ISO",
    "profondeur": "Procédurale",
    "mentionneSolutionsAffaires": true,
    "sourceLabel": "Modèle Cyber Holistique",
    "sourceUrl": "https://app.asana.com/1/1161204849683002/project/1216173532334464/task/1216173449592220"
  },
  {
    "id": "cyber-holistique-1-questionnaire-nist-audit-de-conformite",
    "pilierId": 5,
    "pilierNom": "Modèle Cyber Holistique",
    "tactiqueId": "CH",
    "tactiqueNom": "Tâches du modèle Cyber Holistique",
    "livrableNom": "Questionnaire NIST (audit de conformité)",
    "description": "Tâche importée du modèle Asana Modèle Cyber Holistique.",
    "type": "Rapport",
    "standard": "NIST",
    "profondeur": "Procédurale",
    "mentionneSolutionsAffaires": true,
    "sourceLabel": "Modèle Cyber Holistique",
    "sourceUrl": "https://app.asana.com/1/1161204849683002/project/1216173532334464/task/1216173500990216"
  },
  {
    "id": "cyber-holistique-1-rapport-d-evaluation-des-risques",
    "pilierId": 5,
    "pilierNom": "Modèle Cyber Holistique",
    "tactiqueId": "CH",
    "tactiqueNom": "Tâches du modèle Cyber Holistique",
    "livrableNom": "Rapport d'évaluation des risques",
    "description": "Tâche importée du modèle Asana Modèle Cyber Holistique.",
    "type": "Rapport",
    "standard": "NIST",
    "profondeur": "Procédurale",
    "mentionneSolutionsAffaires": true,
    "sourceLabel": "Modèle Cyber Holistique",
    "sourceUrl": "https://app.asana.com/1/1161204849683002/project/1216173532334464/task/1216173472771503"
  },
  {
    "id": "cyber-holistique-2-protocole-du-test-des-plans",
    "pilierId": 5,
    "pilierNom": "Modèle Cyber Holistique",
    "tactiqueId": "CH",
    "tactiqueNom": "Tâches du modèle Cyber Holistique",
    "livrableNom": "Protocole du test des plans",
    "description": "Tâche importée du modèle Asana Modèle Cyber Holistique.",
    "type": "Rapport",
    "standard": "BZ",
    "profondeur": "Procédurale",
    "mentionneSolutionsAffaires": true,
    "sourceLabel": "Modèle Cyber Holistique",
    "sourceUrl": "https://app.asana.com/1/1161204849683002/project/1216173532334464/task/1216173472771609"
  },
  {
    "id": "cyber-holistique-2-rencontre-discussion-objectifs-annee-2",
    "pilierId": 5,
    "pilierNom": "Modèle Cyber Holistique",
    "tactiqueId": "CH",
    "tactiqueNom": "Tâches du modèle Cyber Holistique",
    "livrableNom": "Rencontre discussion objectifs",
    "description": "Tâche importée du modèle Asana Modèle Cyber Holistique.",
    "type": "Processus",
    "standard": "BZ",
    "profondeur": "Humaine",
    "mentionneSolutionsAffaires": true,
    "sourceLabel": "Modèle Cyber Holistique",
    "sourceUrl": "https://app.asana.com/1/1161204849683002/project/1216173532334464/task/1216173472771905"
  },
  {
    "id": "cyber-holistique-2-retour-sur-le-rer-de-l-annee-1-decision-d-un-plan",
    "pilierId": 5,
    "pilierNom": "Modèle Cyber Holistique",
    "tactiqueId": "CH",
    "tactiqueNom": "Tâches du modèle Cyber Holistique",
    "livrableNom": "Retour sur le RÉR de l'année 1 (décision d'un plan)",
    "description": "Tâche importée du modèle Asana Modèle Cyber Holistique.",
    "type": "Document",
    "standard": "BZ",
    "profondeur": "Procédurale",
    "mentionneSolutionsAffaires": true,
    "sourceLabel": "Modèle Cyber Holistique",
    "sourceUrl": "https://app.asana.com/1/1161204849683002/project/1216173532334464/task/1216173472771911"
  },
  {
    "id": "cyber-holistique-2-test-du-plan-d-intervention-plan-de-reprise",
    "pilierId": 5,
    "pilierNom": "Modèle Cyber Holistique",
    "tactiqueId": "CH",
    "tactiqueNom": "Tâches du modèle Cyber Holistique",
    "livrableNom": "Test du plan d'intervention / plan de reprise",
    "description": "Tâche importée du modèle Asana Modèle Cyber Holistique.",
    "type": "Rapport",
    "standard": "ITIL",
    "profondeur": "Mixte",
    "mentionneSolutionsAffaires": true,
    "sourceLabel": "Modèle Cyber Holistique",
    "sourceUrl": "https://app.asana.com/1/1161204849683002/project/1216173532334464/task/1216173472771621"
  },
  {
    "id": "cyber-holistique-2-test-du-plan-de-sauvegarde",
    "pilierId": 5,
    "pilierNom": "Modèle Cyber Holistique",
    "tactiqueId": "CH",
    "tactiqueNom": "Tâches du modèle Cyber Holistique",
    "livrableNom": "Test du plan de sauvegarde",
    "description": "Tâche importée du modèle Asana Modèle Cyber Holistique.",
    "type": "Rapport",
    "standard": "ITIL",
    "profondeur": "Technologique",
    "mentionneSolutionsAffaires": true,
    "sourceLabel": "Modèle Cyber Holistique",
    "sourceUrl": "https://app.asana.com/1/1161204849683002/project/1216173532334464/task/1216173472771615"
  },
  {
    "id": "cyber-holistique-3-test-d-hameconnage",
    "pilierId": 5,
    "pilierNom": "Modèle Cyber Holistique",
    "tactiqueId": "CH",
    "tactiqueNom": "Tâches du modèle Cyber Holistique",
    "livrableNom": "Test d'hameçonnage",
    "description": "Tâche importée du modèle Asana Modèle Cyber Holistique.",
    "type": "Rapport",
    "standard": "NIST",
    "profondeur": "Technologique",
    "mentionneSolutionsAffaires": true,
    "sourceLabel": "Modèle Cyber Holistique",
    "sourceUrl": "https://app.asana.com/1/1161204849683002/project/1216173532334464/task/1216173486355952"
  },
  {
    "id": "cyber-holistique-3-test-du-plan-d-intervention",
    "pilierId": 5,
    "pilierNom": "Modèle Cyber Holistique",
    "tactiqueId": "CH",
    "tactiqueNom": "Tâches du modèle Cyber Holistique",
    "livrableNom": "Test du plan d'intervention",
    "description": "Tâche importée du modèle Asana Modèle Cyber Holistique.",
    "type": "Rapport",
    "standard": "BZ",
    "profondeur": "Mixte",
    "mentionneSolutionsAffaires": true,
    "sourceLabel": "Modèle Cyber Holistique",
    "sourceUrl": "https://app.asana.com/1/1161204849683002/project/1216173532334464/task/1216173472771714"
  },
  {
    "id": "cyber-holistique-3-test-du-plan-de-reprise",
    "pilierId": 5,
    "pilierNom": "Modèle Cyber Holistique",
    "tactiqueId": "CH",
    "tactiqueNom": "Tâches du modèle Cyber Holistique",
    "livrableNom": "Test du plan de reprise",
    "description": "Tâche importée du modèle Asana Modèle Cyber Holistique.",
    "type": "Rapport",
    "standard": "ITIL",
    "profondeur": "Mixte",
    "mentionneSolutionsAffaires": true,
    "sourceLabel": "Modèle Cyber Holistique",
    "sourceUrl": "https://app.asana.com/1/1161204849683002/project/1216173532334464/task/1216173472771708"
  },
  {
    "id": "cyber-holistique-3-valider-pour-la-suite-des-choses-fermeture-du-dossier",
    "pilierId": 5,
    "pilierNom": "Modèle Cyber Holistique",
    "tactiqueId": "CH",
    "tactiqueNom": "Tâches du modèle Cyber Holistique",
    "livrableNom": "Valider pour la suite des choses / Fermeture du dossier",
    "description": "Tâche importée du modèle Asana Modèle Cyber Holistique.",
    "type": "Processus",
    "standard": "BZ",
    "profondeur": "Mixte",
    "mentionneSolutionsAffaires": true,
    "sourceLabel": "Modèle Cyber Holistique",
    "sourceUrl": "https://app.asana.com/1/1161204849683002/project/1216173532334464/task/1216173501172758"
  }
]
;
